<div class="controls-zone" [ngClass]="drawLeftBorder ? 'with-left-border' : 'no-left-border'" *ngrxLet="session$ as session">
  @if (session && !session.tempUser) {
    @if (enableNotifications) {
      <alg-notification-bell></alg-notification-bell>
    }
    <alg-top-right-menu [styleClass]="topRightMenuStyleClass"></alg-top-right-menu>
  } @else {
    @if (languages.length > 1) {
      <alg-language-picker class="lang-button"></alg-language-picker>
    }
    <button
      icon="ph-bold ph-power"
      (click)="login()"
      alg-button-icon
      [disabled]="isLoginButtonClicked()"
    ></button>
  }
</div>
